import "tippy.js/dist/tippy.css";
import React from "react";
import { Link } from "react-router-dom";
import TextLimit from "Api/TextLimit";
import { Colors } from "enums/Colors";
import { PartsOfDay } from "enums/PartsOfDay";
import { useSelector } from 'react-redux';

export const linkTo = (substitutionId, userRoles) => {
  if (userRoles.includes("requestor") && userRoles.includes("coordinator")) {
    return `/verzoeken/${substitutionId}`;
  } 
  if (userRoles.includes("coordinator")) {
    return `/verzoeken/overzicht/${substitutionId}`;
  }
  if (userRoles.includes("requestor")) {
    return `/verzoeken/${substitutionId}`;
  }
   return '#';
};


function AbsentCell({ getValue }) {
  const value = getValue();
  const userRoles = useSelector(state => state.UserPermission.roles);
  let text = " ";
  var id = 0;
  var substitutionId = 0;
  var status = "";

  if (value && value.length !== 0) {
    if (value.length > 1) {
      text = "Multiple";
    }

    if (value.length === 1) {
      text =
        value[0].vFirstName +
        " " +
        (value[0].vLastName ? value[0].vLastName.charAt(0) : "");
      id = value[0].iSubstitutorAdminId;
      substitutionId = value[0].iSubstitutionId;
      status = TextLimit.codeLimitOptionOne(value[0].vShortName) + " - " + TextLimit.codeLimitOptionOne(value[0].vCode);
    }
    if (value.length > 1) {
      status = "Meerdere";
    }
  }


  return (
    <>
      {substitutionId > 0 ? (
        <Link to={linkTo(substitutionId, userRoles)}>{status}</Link>
      ) : (
        <span className="table-coordinator-planbo ard__conflict-warning">
          {status}
        </span>
      )}
    </>
  );
}

export function convertHeaders(tableHeaders) {
  let formattedHaeders = tableHeaders.map((n, index) => {
    return {
      header: () => n.date,
      id: String(index + 1),
      columns: [
        {
          header: "Ochtend",
          id: n.day.toLowerCase() + "_ochtend",
          accessorKey: n.day.toLowerCase() + "_ochtend",
          cell: AbsentCell,
        },
        {
          header: "Middag",
          id: n.day.toLowerCase() + "_middag",
          accessorKey: n.day.toLowerCase() + "_middag",
          cell: AbsentCell,
        },
      ],
    };
  });
  formattedHaeders.unshift({
    header: " ",
    id: "0",
    columns: [
      {
        header: "Afwezige",
        accessorFn: value => value,
        cell: ({ row }) => {
          const value = row.original;
          return window.innerWidth > 1250
            ? TextLimit.AfwezigeLimitOptionOne(
              value.vFirstName,
              value.vMiddleName,
              value.vLastName
            )
            : TextLimit.AfwezigeLimitOptionTwo(
              value.vFirstName,
              value.vMiddleName,
              value.vLastName
            )
        }
      },
      {
        header: "CT",
        accessorFn: value => value,
        cell: ({ row }) => {
          const value = row.original;
          return window.innerWidth > 1500
            ? TextLimit.limitStringLargeScreen(value.contractTypeAbbr)
            : TextLimit.limitStringSmallScreen(value.contractTypeAbbr)
        }
      },
    ],
  });

  return formattedHaeders;
}

export const isWeekday = (date) => {
  const day = date.getDay();
  return day !== 0 && day !== 6;
};

export function assignColorsToSubstitutions(substitutor) {
  const colorMap = new Map();
  const colorValues = Object.values(Colors);

  Object.values(PartsOfDay).forEach((partOfDay) => {
    if (substitutor[partOfDay] && substitutor[partOfDay].length === 1) {
      substitutor[partOfDay].forEach((substitution) => {
        if (!colorMap.has(substitution.iSubstitutionId)) {
          const color = colorValues[colorMap.size % colorValues.length];
          colorMap.set(substitution.iSubstitutionId, color);
        }
        substitution.vColor = colorMap.get(substitution.iSubstitutionId);
      });
    }
  });
}
